export default {
    "金色主题": "GOLDEN",
    "中文": "Chinese",
    '多元模版' : 'Multi-template version',
    '合作模式' : 'Co-op mode',
    '产品类型' : 'Product type',
    '品牌优势' : 'Brand advantage',
    '合作伙伴' : 'Partners',
    '即刻': 'Now',
    '开始创建属于您的品牌': 'Start creating your own brand',
    '拥有市场趋势' : 'Own market trends',
    '拥有市场趋势 高敏 锐 度' : 'High Acuity',
    '高敏' : 'Ann',
    '锐': 'sharp',
    '度' : 'degree',
    '最新': 'Latest',
    '熱門': 'Hot',
    '五行': 'Wu Xing',
    '星座': 'Constellation',    
    '合作模式' : 'Co-op mode',
    '游戏API对接' : 'Game API docking',
    '八大游戏类型' : 'Eight game genres',
    '区块链、视讯、电子、棋牌、' : 'Blockchain, video, electronics, chess and cards',
    '捕鱼、体育、电竞、彩票，' : 'fishing, sports, esports, lottery,',
    '50间以上国际级游戏平台，破万款游戏，' : 'More than 50 international game platforms, more than 10,000 games,',
    '皆可藉由API对接整合至您的游戏平台上。' : 'All can be integrated into your game platform through API docking.',
    '更多' : 'More',
    '包网建置' : 'White label network construction',
    'JNR提供近百款的模版，': 'JNR provides nearly 100 templates,',
    '快速稳定的数据线路': 'Fast and stable data lines',
    '以及强大的系统防护，' : 'and powerful system protection,',
    '专业的技术团队7x24随时为您服务，' : 'Professional technical team 7x24 at your service,',
    '让您的站点能够站上高峰问鼎全球。' : 'Empower your site to reach the top of the world.',
    'JNR与多家国际游戏商合作，' : 'JNR cooperates with a number of international game providers,',
    '丰富多元的游戏类型，拥上万款游戏，': 'Rich and diverse game types, with tens of thousands of games,',
    '我们将是您最有力的合作伙伴。' : 'We will be your most powerful partner.',
    '包网建站': 'White label network website construction',
    '最多元化的设计风格，最齐全的网站配色，': 'The most diversified design style, the most complete website color,',
    '最多样化的版型配置，' : 'The most diverse fit configuration,',
    'JNR提供给您最完整具时尚、': 'JNR provides you with the most complete stylish,',
    '热门的版型设计，您的需求我们能够一次满足。': 'Hot fit design, we can meet your needs at one time.',
    '区块链': 'Blockchain',
    '视讯': '视讯',
    '电子': '电子',
    '棋牌': '棋牌',
    '捕鱼': '捕鱼',
    '体育': '体育',
    '电竞' : 'Esports',
    '彩票': '彩票',
    '世界顶尖机房': "The world's top computer room",
    '7x24小时全面监控，核心节点极速网络，': '7x24 hours comprehensive monitoring, core node speed network,',
    '多重防护，使您安心的好选择。': 'Multiple protection, a good choice for your peace of mind.',
    '智能数位管理后台': 'Intelligent digital management background',
    '整合最完整的玩家游戏数据、提供最全方位的金流动向分析，' : 'Integrate the most complete player game data and provide the most comprehensive analysis of the flow of money,',
    '揭露第一手最新游戏资讯，让您随时掌握，赢得先机。' : 'Reveal first-hand game information so you can stay on top and get a head start.',
    'BB区块链xSHA加密技术，多重加密无法串改，': 'BB blockchain xSHA encryption technology, multiple encryption can not be changed,',
    '领先业界，缔造全球娱乐飨宴，尽在JNR。': 'Leading the industry and creating a global entertainment feast, all at JNR.',
    '真人视讯': 'Live Video',
    '最据临场感真人荷官发牌，24小时线上即时开牌不间断，': 'The most immersive real dealer dealers, 24-hour online instant opening uninterrupted,',
    '所有好玩新事物尽在JNR。': 'All the fun and new things in JNR.',
    '电子游戏': 'Video game',
    'JNR与30家以上国际级游戏商合作，': 'JNR cooperates with more than 30 international game companies,',
    '破万款电子游戏，随君挑选。': 'Break 10,000 video games, choose as you like.',
    '棋牌游戏': 'Board games',
    '从明清时期盛行至今，玩法多元丰富': 'Since the Ming and Qing dynasties, the gameplay has been diversified and rich',
    '斗地主、炸金花、牛牛，依然稳坐热搜排行榜，': 'Fighting landlords, fried golden flowers, cows and cows, still firmly on the hot search rankings,',
    '深受华人地区玩家喜爱。': 'Loved by players in Chinese areas.',
    '捕鱼游戏': 'Fishing games',
    '现今电玩城里最火红的游戏类型，': 'The hottest game genre in the video game city today,',
    '透由剧情以炮弹系统攻击，捕获成功，': 'Attacked by the cannonball system in the plot, captured successfully,',
    '鱼儿们将化成數不尽的金币，塞满屏幕，欢乐无比。' : 'The fish will turn into countless gold coins, fill the screen, and have a lot of joy.',
    '体育赛事': 'Sporting events',
    '提供上万场体育赛事投注，覆盖世界各地赛事，': 'Provide tens of thousands of sports event bets, covering events around the world,',
    '让球、大小、半全场、波胆、单双、总入球、连串过关等多元竞猜，': 'Handicap, size, half-court, wave gall, single and even, total goal, series of passes and other multiple guesses,',
    '年创百亿商机等您来+1。': 'Tens of billions of business opportunities are waiting for you to +1.',
    '电子竞技': 'Esports',
    '提供时下最流行的电子竞技，拥有顶尖的技术支持与令人惊叹的视觉界面。': 'Offering the most popular esports with top-notch technical support and stunning visual interface.',
    '让您的电竞玩家轻松上手，一目了然，轻松投注。': 'Make it easy for your esports players to get started, at a glance, and bet with ease.',
    '彩票游戏': 'Lottery games',
    'JNR多样独家创新玩法，彩种丰富多元；': 'JNR has a variety of exclusive and innovative gameplay, rich and diversified colors;',
    '公平可验证的区块链技术，界面简单易懂，新世代玩法不容错过。': 'Fair and verifiable blockchain technology, simple and easy-to-understand interface, the new generation of gameplay is not to be missed.',
    'H5移动端APP': 'H5 mobile APP',
    '随登即玩，一机在手，快乐随时拥有。': 'Play as you go, a machine in hand, happiness at any time.',
    '专业的技术服务团队': 'Professional technical service team',
    '全年365天，7x24小时，': '365 days a year, 7x24 hours,',
    '专业技术团队随时为您服务。': 'A professional technical team is at your service.',
    'JNR自建顶尖高防数据中心，全球布局光纤缆线，数据中心拥全球国际稳定线路，完美防护，顶尖网络设施就在JNR。': 'JNR has built its own top high-defense data center, global layout of optical fiber cables, data center has global international stable lines, perfect protection, top network facilities are in JNR.',
    '智能数位管理后台': 'Intelligent digital management background',
    'JNR提供最完整的数位管理后台系统，让您洞悉玩家游戏动态，掌握资金来龙去脉，随时调整运营方针。': "JNR provides the most complete digital management background system, allowing you to gain insight into players' game dynamics, grasp the ins and outs of funds, and adjust operation policies at any time.",
    'H5移动端APP': 'H5 mobile APP',
    '运用扫脸、指纹，手势密码快速登入，随点即玩，让您的娱乐永不断线。': 'Use face scanning, fingerprint, gesture password to quickly log in, play at any time, so that your entertainment will never stop.',
    '专业的技术服务团队' : 'Professional technical service team',
    'JNR提供7x24小时专人线上咨询，以提升客户满意度为最高宗旨，而提供最全方位的技术服务是我们对您的坚持。': 'JNR provides 7x24 hours dedicated online consultation, to improve customer satisfaction as the highest purpose, and to provide the most comprehensive technical service is our insistence on you.',
    '全部' : 'All',
    '电子': 'Electron',
    '体育': 'P. E.',
    '棋牌': 'Cards',
    '视讯': 'Video',
    '彩票' : 'Lottery',
    '捕鱼': 'Catch fish',
    '综合': 'Synthesis',
    "综合主题": "Casino Theme",
    '国际象棋和纸牌': 'Casino Theme',
    '棋牌': 'Casino Theme',
    '产品类型': 'Product Type',
    '合作伙伴': 'Partner',
    '时尚多元前台模版': 'Stylish multi-front office template',
    'JNR提供近百款的模版, 各式版型风格,': 'JNR provides nearly 100 templates, all kinds of style of version,',     
    "黑金主题" : "Black gold theme",
    "黑色主题5" : "Black Theme 5",
    "黑色主题4" : "Black Theme 4",
    "黑色主题3" : "Black Theme 3",
    "黑色主题2" : "Black Theme 2",
    "黑色主题" : "Black Theme",
    "过年主题2" : "New Year theme 2",
    "过年主题1" : "New Year theme 1",
    "蓝色主题": "Blue theme",
    "综合彩票" : "Comprehensive lottery",
    "比格温": "Bigwin",
    "新综合主题": "New comprehensive theme",
    "新彩票" : "New lottery",
    "彩票主题": "Lottery",
    "太阳城": "Sun City",
    "古黑主题" : "Ancient Black theme",
    "全民彩票主题" : "National lottery theme",
    "体育Phlwin" : "Sports Phlwin",
    "体育black" : "Sports black",
    "MAXIM88主题" : "Maxim88 theme",
    "bet365主题": "bet365 theme",
    "23-深蓝" : "23 - Navy blue",
    "23- 深黑" : "23- Deep black",
    "细节" : "Detail",
    "现场演示" : "Live Demo",
    "所有款式" : "All styles",
    "产品类型" : "Product type",
    "创新" : "innovation",
    "的视觉呈": "of visual presentation",
    "现" : "appear",
    "独特": "unique",
    "选版": "Selected editions",
    "手机选版": "Mobile phone selection",
    "展现个人": "Show the individual",
    "品牌的" : "brand",
    "价": "price",
    "值": "value",
    "设": "establish",
    "计最具": "Count the most",
    "竞争力": "Competitiveness", 
    "的" : "target",
    "版": "edition",
    "面": "face",
    "从此简单": "It's been simpler",
    "选择" : "CHOOSE",
    "立即创建您自己的品牌": "create your own brand now",
    '众多色系搭配，展现出个人品牌风格或协助制作仿站.': 'Numerous color combinations to show personal brand style or assist in the production of imitation stations.',
    '众多色系搭配' : 'Lots of color combinations',
    '展现出个人品牌风格或协助制作仿站' : 'Show your personal brand style or assist in the production of imitation sites',
    "支持语言": "Supported languages",
    "西班牙语/葡萄牙语/马来语/印度尼西亚语（印尼语）/孟加拉语/英语/印地语/泰语/土耳其语/越南语/中文繁体/中文简体": "Spanish/Portuguese/Malay/Indonesian/English/Thai/Turkish/Vietnamese/Chinese Traditional/Chinese Simplified",
    "测试域名": "Testing address",
    "电脑端": "PC",
    "手机端": "MOBILE",
    "测试账号": "User",
    "说明": "Description",
    "经典主题": "Classic theme",
    "AK8主题": "AK8 theme",
    "990主题": "990 theme",
    "版本1": "VERSION#1",
    "版本2": "VERSION#2",
    "网赚彩票": "WZLottery",
    "网赚彩票2": "WZLottery2",
    "网赚综合": "WZCASINO",
    "网赚公益": "WZGY",
    "网赚购物1": "WZGW1",
    "网赚购物2": "WZGW2",
    "网赚购物3": "WZGW3",
    "网赚购物4": "WZGW4",
    "网赚购物5": "WZGW5",
    "网赚购物6": "WZGW6",
    "网赚购物7": "WZGW7",
    "网赚购物8": "WZGW8",
    "网赚购物9": "WZGW9",
    "网赚购物10": "WZG10",
    "网赚投资": "INVESTMENT",
    "约会主题1": "DATE#1",
    "约会主题2": "DATE#2",
    "酷主题": "KU",
    "酷主题2": "KU2",
    "娱乐城主题": "CASINO",
    "新年主题": "NEW YEAR",
    "新年主题2": "NEW YEAR 2",
    "体育主题": "SPORT",
    "太阳城主题": "SUNCITY",
    "THAI主题": "THAI",
    "THAI主题2": "THAI#2",
    "BIGWIN主题": "BIGWIN",
    "基础主题": "BASIC",
    "可用于约会的专项站点，适用于做裂变以及其他运营模式": "Apply to the sites about dating with stranger. It's suitable for fission and other operation mode.",
    "中文简体/印尼语/英语/印地语/越南语": "Chinese Simplified/Indonesian/English/Hindi/Vietnamese",
    "可用于基于彩票的投资站点": "Apply to the sites about investment.",
    "中文(简体)/中文(繁体)/英语/越南/泰语/马来语/印尼语/葡萄牙语/西班牙语/俄语/阿拉伯语/法语/保加利亚/波兰语/土耳其语/俄语/巴黎/日语/印度语/韩语": "Chinese (Simplified)/Chinese (Traditional)/English/Vietnam/Thai/Malay/Indonesian/Portuguese/Spanish/Russian/Arabic/French/Bulgarian/Polish/Turkish/Russian/Paris/Japanese/ Indian/Korean",
    "适用于彩票站点的推广运营，并支持国际化，包含多种语言，而且也有多种版本，包括依托彩票而演变的其他版本及推广模式": "Apply to the site about lottery, and support international operation with multiple languages. It includes multiple versions which suitable for different operation mode based on lottery.",
    "适用于综合信用及体育盘口. 里面包含了电子, 棋牌, 捕鱼, 哈希游戏, 体育, 真人视讯, 彩票等市面绝大多数主流游戏. 这是一款国际化产品, 支持多种语言, 而且里面设计了很多针对性的会员任务及活动" : "Apply to casino website which includes slots, poker, fishing, hash game, sports, live casino and lottery. Its an international product with multiple languages supported and there are many designed member tasks and activities.",
    //"拥有市场趋势" : " Own market trends"
    "适用于综合信用及体育盘口。里面包含了电子，棋牌，捕鱼，哈希游戏，体育，真人视讯，彩票等市面绝大多数主流游戏。这是一款国际化产品，支持多种语言，而且里面设计了很多针对性的会员任务及活动。": "Apply to casino website which includes slots, poker, fishing, hash game, sports, live casino and lottery. It's an international product with multiple languages supported and there are many designed member tasks and activities."
}
